<template>
  <div class="recharge_left capital_first">
    <div class="perfect_content">
      <div class="content_title">{{$t('pc.myaccount.funding_details')}}</div>
      <div class="content_declare">
        <!-- <ul class="ca_ul1">
          <li>
            <a>时间：</a>
          </li>
          <li class="ca_li ca_li_active">
            <a href="#">全部</a>
          </li>
          <li class="ca_li">
            <a href="#">一个星期</a>
          </li>
          <li class="ca_li">
            <a href="#">一个月</a>
          </li>
          <li class="ca_li">
            <a href="#">三个月</a>
          </li>
          <li class="ca_li">
            <a href="#">一年</a>
          </li>
        </ul>-->
        <ul class="ca_ul2">
          <li>
            <a>{{$t('pc.trading.type')}}：</a>
          </li>
          <li class="ca_li1">
            <el-button :class="nozzle =='all_log' ? 'back-blue':''" @click="getList('all_log')">{{$t('pc.myaccount.full_details')}}</el-button>
          </li>
          <li class="ca_li1">
            <el-button
              :class="nozzle =='recharge_log' ? 'back-blue':''"
              @click="getList('recharge_log')"
            >{{$t('pc.capital.recharge')}}
            </el-button>
          </li>
          <li class="ca_li1">
            <el-button
              :class="nozzle =='withdraw_log' ? 'back-blue':''"
              @click="getList('withdraw_log')"
            >{{$t('pc.capital.withdraw')}}
            </el-button>
          </li>
          <li class="ca_li1">
            <el-button
              :class="nozzle =='loan_log' ? 'back-blue':''"
              @click="getList('loan_log')"
            >{{$t('pc.myaccount.loan_details')}}
            </el-button>
          </li>
          <!--<li class="ca_li1">
            <el-button
              :class="nozzle =='loan_log' ? 'back-blue':''"
              @click="getList('loan_log')"
            >结算明细</el-button>
          </li>-->
          <!--<li class="ca_li1">
            <el-button
              :class="nozzle =='extract_log' ? 'back-blue':''"
              @click="getList('extract_log')"
            >利润提取</el-button>
          </li>-->
          <li class="ca_li1">
            <el-button
              :class="nozzle =='manage_log' ? 'back-blue':''"
              @click="getList('manage_log')"
            >{{$t('pc.myaccount.administrative_fees')}}
            </el-button>
          </li>
          <li class="ca_li1">
            <el-button
              :class="nozzle =='vouchermanage_log' ? 'back-blue':''"
              @click="getList('vouchermanage_log')"
            >{{$t('pc.operate.voucher')}}
            </el-button>
          </li>
          <li class="ca_li1">
            <el-button
              :class="nozzle =='give_back' ? 'back-blue':''"
              @click="getList('give_back')"
            >{{$t('pc.myaccount.cash_back')}}
            </el-button>
          </li>
        </ul>
      </div>
      <div class="content_details">
        <el-table :data="list" height="500" border stripe style="width: 100%">
          <el-table-column prop="time" :label="$t('pc.trading.time')" width="170"> <template slot-scope="scope">
                <p>{{ $getDeviceTime(scope.row.time) }}</p>
              </template></el-table-column>
          <el-table-column prop="name" :label="$t('pc.trading.type')" width="170"><template slot-scope="scope"> <span v-if="scope.row.capital">{{ $t(scope.row.capital) }} </span>    {{ $t(scope.row.name) }}  </template></el-table-column>
          <el-table-column prop="number" :label="$t('pc.trading.amount')" width="170"></el-table-column>
          <el-table-column v-if="nozzle==='recharge_log' || nozzle==='withdraw_log'" prop="exchange" 
                           :label="$t('pc.myaccount.amount_rmb')" width="170"></el-table-column>
          <el-table-column prop="balance" :label="$t('pc.trading.balance')"></el-table-column>
          <el-table-column v-if="nozzle==='recharge_log' || nozzle==='withdraw_log'" prop="status" :label="$t('pc.trading.status')"><template slot-scope="scope">{{ $t(scope.row.status) }}</template></el-table-column> 
        </el-table>
       <!-- <el-pagination
          v-if="nozzle==='recharge_log' || nozzle==='withdraw_log'"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-count="page">
        </el-pagination>-->
      </div>
    </div>
  </div>
</template>
<script>
  import $ from "jquery";

  export default {
    name: "Detailed",
    data() {
      return {
        list: [],
        nozzle: "all_log",
        page: 1
      };
    },
    mounted: function () {
      this.getList("all_log", 1);
    },
    methods: {
      getList(nozzle, type) {
        let that = this;
        if (that.nozzle != nozzle || type == 1) {
          that.nozzle = nozzle;
          if (nozzle === 'give_back') {
            that.$http({
              url: "/",
              method: "post",
              data: {
                nozzle: 'all_log',
                token: sessionStorage.getItem("token"),
                type: 14
              }
            })
              .then(function (res) {
                if (res.data.code == 1) {
                  /*if (res.data.data.length == 0) {
                    that.$message.error("暂无数据");
                  } else {
                    that.list = res.data.data;
                  }*/
                  that.list = res.data.data;
                } else if (res.data.code == 0) {
                  that.$message.error(that.$t(res.data.msg));
                }
              });
          } else {
            that.$http({
              url: "/",
              method: "post",
              data: {
                nozzle: nozzle,
                token: sessionStorage.getItem("token")
              }
            })
              .then(function (res) {
                if (res.data.code == 1) {
                  /*if (res.data.data.length == 0) {
                    that.$message.error("暂无数据");
                  } else {
                    that.list = res.data.data;
                  }*/
                  if (nozzle === 'recharge_log' || nozzle === 'withdraw_log') {
                    let list = res.data.data.data;
                    if (nozzle === 'recharge_log') {
                      let temp = list;
                      for (let i = 0, len = temp.length; i < len; i++) {
                        switch (temp[i].status) {
                          case 0:
                            temp[i].status = that.$t("pc.recharge_log.status1");
                            break;
                          case 1:
                            temp[i].status = that.$t("pc.recharge_log.status2");
                            break;
                          case 2:
                            temp[i].status = that.$t("pc.recharge_log.status3");
                            break;
                        }
                      }
                      that.list = temp;
                      that.page = res.data.data.page
                    } else {
                      that.list = list;
                    }
                  } else {
                    that.list = res.data.data;
                  }
                } else if (res.data.code == 0) {
                  that.$message.error(that.$t(res.data.msg));
                }
              });
          }

        }
      },
      handleCurrentChange(page) {
        let that = this;
        let nozzle = that.nozzle;
        if (nozzle === 'recharge_log') {
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: nozzle,
              token: sessionStorage.getItem("token"),
              page: page
            }
          })
            .then(function (res) {
              if (res.data.code == 1) {
                let resData = res.data;
                let temp = resData.data.data;
                for (let i = 0, len = temp.length; i < len; i++) {
                  switch (temp[i].status) {
                    case 0:
                      temp[i].status = '等待审核';
                      break;
                    case 1:
                      temp[i].status = '充值成功';
                      break;
                    case 2:
                      temp[i].status = '充值失败';
                      break;
                  }
                }
                that.page = resData.data.page;
                that.list = temp;
              } else if (res.data.code == 0) {
                that.$message.error(that.$t(res.data.msg));
              }
            });
        } else if (nozzle === 'withdraw_log') {
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: nozzle,
              token: sessionStorage.getItem("token"),
              page: page
            }
          })
            .then(function (res) {
              if (res.data.code == 1) {
                let resData = res.data;
                that.page = resData.data.page;
                that.list = resData.data.data;
              } else if (res.data.code == 0) {
                that.$message.error(that.$t(res.data.msg));
              }
            });
        }
      },
    }
  };
</script>
<style scoped>
  .back-blue {
    background: #566b96 !important;
    color: #fff !important;
  }

  .perfect_title {
    width: 100%;
    height: 70px;
    text-align: left;
    margin-bottom: 50px;
    border-bottom: 1px solid #2b7ea8;
  }

  .perfect_title div {
    text-align: center;
    width: 100px;
    height: 69px;
    line-height: 69px;
    color: #2b7ea8;
    font-weight: 600;
    margin-left: 12px;
    border-bottom: 2px solid #2b7ea8;
  }

  .perfect_content {
    width: 100%;
    margin: 20px auto 0;
    border: 1px solid #ccc;
    padding-bottom: 20px;
  }

  .content_title {
    height: 80px;
    line-height: 100px;
    font-size: 20px;
    text-align: left;
    margin: 0 20px;
    font-weight: 1000;
    border-bottom: 1px solid #ccc;
  }

  .content_declare {
    height: 100px;
    line-height: 40px;
    color: #8388a5;
    font-size: 18px;
    font-weight: 600;
    text-align: left;
    padding-left: 20px;
    border-top: 1px solid white;
  }

  /*资金明细*/
  .content_declare > ul:first-child {
    margin-top: 30px;
    margin-bottom: 10px;
  }

  .content_declare > ul > li {
    display: inline-block;
  }

  .content_declare > ul > li:first-child > a {
    padding: 0;
    width: auto;
  }

  .content_declare > ul > li > a {
    display: inline-block;
    color: #000;
    font-size: 16px;
    line-height: 35px;
    width: 85px;
    text-align: center;
    color: #566b96;
  }

  .ca_li_active > a {
    background: #566b96 !important;
    color: #fff !important;
  }

  .content_details {
    width: 960px;
    margin-left: 15px;
    text-align: center;
  }

  .details_title {
    width: 100%;
    height: 55px;
    line-height: 55px;
    text-align: center;
    background-color: #f2f2f2;
  }

  .details_title div {
    display: inline-block;
    width: 8%;
    margin: 0;
    padding: 0;
    color: #444;
  }

  .details_title div:first-child {
    width: 20%;
  }

  .details_title div:last-child {
    width: 30%;
  }

  .content_content {
    width: 960px;
    text-align: center;
  }

  .details_first div {
    width: 8%;
    height: 55px;
    line-height: 55px;
    display: inline-block;
    font-size: 14px;
    color: #999;
  }

  .details_first div:first-child {
    width: 20%;
  }

  .details_first div:last-child {
    width: 30%;
  }

  .M-box2 {
    float: right;
    margin-top: 30px;
  }
</style>





// WEBPACK FOOTER //
// src/components/detailed.vue